<!--  crud table -->
<template>
  <v-container grid-list-md id="VIDEO">
    <v-btn @click="click"> Open </v-btn>
    <user-dlg v-model="dlgShow" :objNm="objNm" @selectItem="onSelectItem">
    </user-dlg>

    {{ returnVal }}
    dlgShow {{ dlgShow }}
  </v-container>
</template>

<script>
/**
 * Table
 * 호춯 순서.
 * created...
 *
 *   params 의 객체명 과 page 값을 가지고 온다. (인자가 없으면 1)
 *
 *
 *
 */
import _ from "lodash";
import UserDlg from "@/components/controls/UserDlg";
export default {
  components: {
    UserDlg,
  },
  data() {
    return {
      dlgShow: false,
      objNm: "User",
      returnVal: {},
    };
  },
  computed: {},
  //page created
  created() {},

  watch: {},
  methods: {
    onSelectItem(item) {
      console.log("onSelect", item);
      this.returnVal = item;
    },
    // create 이후 초기화
    async initialize() {
      console.log("#2 initiallize");
    },
    click() {
      console.log("click.");
      this.dlgShow = true;
    },
  },
};
</script>
<style>
#VIDEO .v-overlay__content {
  width: 100%;
  height: 100%;
}
#VIDEO .v-overlay__content .unicon {
  position: absolute;
  z-index: 99;
}
.unicon {
  fill: #ffffff;
  stroke: rgba(0, 0, 0, 0.5);
  vertical-align: middle;
  top: 10px;
  left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/etc/test.vue